<template>
  <div class="platform-page">
    <h1>{{ platformName }} Gaming</h1>
    <p>Latest news, reviews and guides for {{ platformName }}.</p>
  </div>
</template>

<script>
import { generateListPageMetaInfo, buildBreadcrumbs } from '@/utils/seo'

export default {
  name: 'PlatformPage',
  computed: {
    platformName() {
      const slug = this.$route.params.slug
      return slug.toUpperCase()
    },
  },
  methods: {
    generateListPageMetaInfo,
  },
  metaInfo() {
    const breadcrumbs = buildBreadcrumbs(this.$route, {
      current: `${this.platformName} Gaming`,
    })

    return generateListPageMetaInfo({
      title: `${this.platformName} Gaming`,
      description: `Latest gaming news, reviews and guides for ${this.platformName}. Stay updated with ${this.platformName} exclusive content.`,
      path: this.$route.path,
      breadcrumbs,
    })
  },
}
</script>

<style lang="scss" scoped>
@use '@/css/variables.scss' as *;

.platform-page {
  h1 {
    font-size: $font-size-xxl;
    margin-bottom: $spacing-md;
  }

  p {
    font-size: $font-size-lg;
    color: $text-secondary;
  }
}
</style>
